import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

// const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490, 4000, 3000, 2000, 2780, 1890, 2390, 3490];
// const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300, 2400, 1398, 9800, 3908, 4800, 3800, 4300];
// const xLabels = ["Page A", "Page B", "Page C", "Page D", "Page E", "Page F", "Page G", "Page H", "Page I", "Page J", "Page K", "Page L", "Page M", "Page N"];

export default function SimpleBarChart({ rawData }) {
  const locationLabels = rawData?.map((item) => item?.location_name);
  const paidData = rawData?.map((item) => item?.paid ?? 0);
  const postedData = rawData?.map((item) => item?.posted ?? 0);

  return (
    <BarChart
      height={400}
      series={[
        { data: paidData, label: "Paid", id: "paid_data" },
        { data: postedData, label: "Posted", id: "posted_data" },
      ]}
      // barLabel={(item, context) => {
      //   return item.value?.toString();
      // }}
      xAxis={[{ data: locationLabels }]}
      yAxis={[{ width: 50 }]}
    />
  );
}
